// @ts-nocheck
(function () {
  const root = document.querySelector("[data-security-root]");
  if (!root) return; // not on this page

  const { ACCOUNT, CHANGE_PASSWORD } = window.AccountEndpoints;
  const { authFetch } = window.AccountHttp;
  const { GENERIC, VALIDATION, SECURITY, ACCOUNT_UI } = window.AccountMessages;

  const successBox = root.querySelector("[data-security-success]");

  // Customizer-editable text

  const closeLabel = root.dataset.closeLabel || ACCOUNT_UI.CLOSE;
  const confirmUpdatePasswordMessage =
    root.dataset.confirmUpdatePassword || SECURITY.CONFIRM_UPDATE_PASSWORD;
  const confirmDeleteAccountMessage =
    root.dataset.confirmDeleteAccount || SECURITY.CONFIRM_DELETE_ACCOUNT;

  // PASSWORD card

  const passwordCard = root.querySelector('[data-account-field="password"]');
  const passwordToggle = passwordCard
    ? passwordCard.querySelector("[data-account-toggle]")
    : null;
  const passwordToggleLabel = passwordCard
    ? passwordCard.querySelector("[data-toggle-label]")
    : null;
  const passwordPanel = passwordCard
    ? passwordCard.querySelector("[data-account-panel]")
    : null;
  const passwordErrorBox = passwordCard
    ? passwordCard.querySelector("[data-account-error]")
    : null;
  const passwordSubmitBtn = passwordCard
    ? passwordCard.querySelector("[data-account-submit]")
    : null;

  const currentPasswordInput = document.getElementById(
    "SecurityCurrentPassword",
  );
  const newPasswordInput = document.getElementById("SecurityNewPassword");
  const confirmPasswordInput = document.getElementById(
    "SecurityConfirmPassword",
  );

  const passwordUpdatedValueEl = root.querySelector(
    "[data-password-updated-value]",
  );

  // DELETE ACCOUNT card

  const deleteErrorBox = root.querySelector("[data-delete-error]");
  const deleteBtn = root.querySelector('[data-action="delete-account"]');

  // Shared confirm modal

  const confirmOverlay = document.querySelector(
    "[data-security-confirm-overlay]",
  );
  const confirmMessageEl = document.querySelector(
    "[data-security-confirm-message]",
  );
  const confirmCancelBtn = document.querySelector(
    "[data-security-confirm-cancel]",
  );
  const confirmConfirmBtn = document.querySelector(
    "[data-security-confirm-confirm]",
  );

  function showConfirm(message, onConfirm) {
    if (
      !confirmOverlay ||
      !confirmMessageEl ||
      !confirmConfirmBtn ||
      !confirmCancelBtn
    ) {
      if (window.confirm(message)) onConfirm();
      return;
    }

    confirmMessageEl.textContent = message;
    confirmOverlay.hidden = false;

    function cleanup() {
      confirmOverlay.hidden = true;
      confirmConfirmBtn.removeEventListener("click", handleConfirm);
      confirmCancelBtn.removeEventListener("click", handleCancel);
      confirmOverlay.removeEventListener("click", handleOverlayClick);
    }

    function handleConfirm() {
      cleanup();
      onConfirm();
    }

    function handleCancel() {
      cleanup();
    }

    function handleOverlayClick(event) {
      if (event.target === confirmOverlay) cleanup();
    }

    confirmConfirmBtn.addEventListener("click", handleConfirm);
    confirmCancelBtn.addEventListener("click", handleCancel);
    confirmOverlay.addEventListener("click", handleOverlayClick);
  }

  function showSuccess(message) {
    if (!successBox) return;
    successBox.textContent = message;
    successBox.hidden = false;
    successBox.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function showFieldError(errorBox, message) {
    if (!errorBox) return;
    errorBox.textContent = message;
    errorBox.hidden = false;
  }

  function hideFieldError(errorBox) {
    if (!errorBox) return;
    errorBox.hidden = true;
    errorBox.textContent = "";
  }

  function setBusy(button, busy, busyLabel) {
    if (!button) return;
    button.disabled = busy;
    const labelEl = button.querySelector("[data-btn-label]");
    if (busy) {
      button.dataset.originalLabel = labelEl
        ? labelEl.textContent
        : button.textContent;
      if (labelEl) labelEl.textContent = busyLabel || ACCOUNT_UI.PLEASE_WAIT;
    } else if (labelEl && button.dataset.originalLabel) {
      labelEl.textContent = button.dataset.originalLabel;
    }
  }

  function formatDate(isoString) {
    try {
      const d = new Date(isoString);
      if (isNaN(d.getTime())) return isoString;
      return (
        d.toLocaleDateString(undefined, {
          day: "numeric",
          month: "long",
          year: "numeric",
        }) +
        " at " +
        d.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    } catch (err) {
      return isoString;
    }
  }

  function loadAccount() {
    return authFetch(ACCOUNT, { method: "GET" })
      .then(function (res) {
        if (!res.ok) {
          console.error(
            "[security-settings] Failed to load account:",
            res.data,
          );
          return;
        }

        const account = res.data.result || res.data;
        if (account.lastPasswordChanged && passwordUpdatedValueEl) {
          passwordUpdatedValueEl.textContent = formatDate(
            account.lastPasswordChanged,
          );
        }
      })
      .catch(function (err) {
        console.error("[security-settings] Failed to load account:", err);
      })
      .finally(function () {
        root.classList.remove("is-loading");
      });
  }

  loadAccount();

  // Toggle open/close for the password card

  if (passwordToggleLabel) {
    passwordToggleLabel.dataset.openLabel = passwordToggleLabel.textContent;
  }

  if (passwordToggle && passwordPanel) {
    passwordToggle.addEventListener("click", function () {
      const isOpen = !passwordPanel.hidden;
      passwordPanel.hidden = isOpen;
      if (passwordToggleLabel) {
        passwordToggleLabel.textContent = isOpen
          ? passwordToggleLabel.dataset.openLabel ||
            passwordToggleLabel.textContent
          : closeLabel;
      }
      if (passwordErrorBox) passwordErrorBox.hidden = true;
    });
  }

  // Keep the update-password button disabled until all fields are filled

  function updatePasswordSubmitState() {
    if (!passwordSubmitBtn) return;
    const oldPassword = currentPasswordInput ? currentPasswordInput.value : "";
    const newPassword = newPasswordInput ? newPasswordInput.value : "";
    const confirmNewPassword = confirmPasswordInput
      ? confirmPasswordInput.value
      : "";
    passwordSubmitBtn.disabled = !(
      oldPassword &&
      newPassword &&
      confirmNewPassword
    );
  }

  [currentPasswordInput, newPasswordInput, confirmPasswordInput].forEach(
    function (input) {
      if (input) input.addEventListener("input", updatePasswordSubmitState);
    },
  );

  // POST /auth/change-password

  if (passwordSubmitBtn) {
    passwordSubmitBtn.addEventListener("click", function () {
      hideFieldError(passwordErrorBox);

      const oldPassword = currentPasswordInput
        ? currentPasswordInput.value
        : "";
      const newPassword = newPasswordInput ? newPasswordInput.value : "";
      const confirmNewPassword = confirmPasswordInput
        ? confirmPasswordInput.value
        : "";

      if (!oldPassword) {
        showFieldError(passwordErrorBox, VALIDATION.MISSING_CURRENT_PASSWORD);
        return;
      }
      if (newPassword.length < 8) {
        showFieldError(passwordErrorBox, VALIDATION.PASSWORD_TOO_SHORT);
        return;
      }
      if (newPassword !== confirmNewPassword) {
        showFieldError(passwordErrorBox, VALIDATION.PASSWORDS_DO_NOT_MATCH);
        return;
      }

      showConfirm(confirmUpdatePasswordMessage, function () {
        setBusy(passwordSubmitBtn, true, ACCOUNT_UI.SAVING);

        authFetch(CHANGE_PASSWORD, {
          method: "POST",
          body: JSON.stringify({
            oldPassword: oldPassword,
            newPassword: newPassword,
            confirmNewPassword: confirmNewPassword,
          }),
        })
          .then(function (res) {
            if (!res.ok) {
              showFieldError(
                passwordErrorBox,
                (res.data && res.data.message) || SECURITY.UPDATE_FAILED,
              );
              return;
            }
            if (currentPasswordInput) currentPasswordInput.value = "";
            if (newPasswordInput) newPasswordInput.value = "";
            if (confirmPasswordInput) confirmPasswordInput.value = "";
            updatePasswordSubmitState();

            if (passwordPanel) passwordPanel.hidden = true;
            if (passwordToggleLabel)
              passwordToggleLabel.textContent = ACCOUNT_UI.UPDATE_PASSWORD;
            if (passwordUpdatedValueEl) {
              passwordUpdatedValueEl.textContent = formatDate(
                new Date().toISOString(),
              );
            }

            showSuccess(SECURITY.UPDATED);
          })
          .catch(function () {
            showFieldError(passwordErrorBox, GENERIC.NETWORK_ERROR);
          })
          .finally(function () {
            setBusy(passwordSubmitBtn, false);
            updatePasswordSubmitState();
          });
      });
    });
  }

  // C9 — DELETE /customer/account

  if (deleteBtn) {
    deleteBtn.addEventListener("click", function () {
      if (deleteErrorBox) deleteErrorBox.hidden = true;

      showConfirm(confirmDeleteAccountMessage, function () {
        setBusy(deleteBtn, true, ACCOUNT_UI.DELETING);

        authFetch(ACCOUNT, { method: "DELETE" })
          .then(function (res) {
            if (!res.ok) {
              showFieldError(
                deleteErrorBox,
                (res.data && res.data.message) || SECURITY.DELETE_FAILED,
              );
              return;
            }
            if (window.AccountAuth) window.AccountAuth.clearSession();
            window.location.href = "/pages/login?message=account-deleted";
          })
          .catch(function () {
            showFieldError(deleteErrorBox, GENERIC.NETWORK_ERROR);
          })
          .finally(function () {
            setBusy(deleteBtn, false);
          });
      });
    });
  }
})();
